import React from 'react';
import { Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  icon: '⚙️',
  title: 'Sistema Operativo del Ingeniero a Bordo™',
  subtitle: 'Cómo eliminar fallas, anticiparse a problemas y mantener el barco funcionando sin sorpresas',
  resolves: ['Fallas inesperadas', 'Desorden técnico', 'Falta de control en mantenimiento'],
  includes: ['Checklist de mantenimiento diario / semanal', 'Planilla de control de sistemas (motor, agua, electricidad)', 'Registro de incidencias técnicas', 'Protocolo de comunicación con capitán', 'Rutina preventiva paso a paso'],
  value: {
    crew: 'El ingeniero sabe exactamente qué hacer',
    captain: 'Vos podés supervisar sin ser técnico'
  }
}, {
  icon: '🍽️',
  title: 'Sistema Profesional del Chef de Charter™',
  subtitle: 'Cómo ofrecer una experiencia gastronómica premium sin caos en cocina',
  resolves: ['Mala planificación', 'Falta de organización en cocina', 'Desconexión con el ritmo del barco'],
  includes: ['Planificador de menús según cliente', 'Control de stock e inventario', 'Cronograma de preparación diario', 'Checklist de servicio', 'Sistema de coordinación con capitán'],
  value: {
    crew: 'El chef trabaja con claridad',
    captain: 'Vos controlás la experiencia del cliente'
  }
}, {
  icon: '🧼',
  title: 'Sistema Elite de Azafata / Stewardess™',
  subtitle: 'Cómo crear una experiencia de lujo que los clientes recuerdan',
  resolves: ['Falta de estándares', 'Desorden en cabinas', 'Servicio inconsistente'],
  includes: ['Checklist de limpieza profesional (tipo hotel 5⭐)', 'Rutina diaria de orden y presentación', 'Guía de atención al cliente', 'Detalles premium que marcan la diferencia', 'Sistema de organización de espacios'],
  value: {
    crew: 'La azafata ejecuta con excelencia',
    captain: 'Vos asegurás calidad constante'
  }
}, {
  icon: '⚓',
  title: 'Sistema del Marinero Profesional™',
  subtitle: 'Cómo ejecutar tareas con precisión, disciplina y eficiencia',
  resolves: ['Falta de claridad en tareas', 'Errores operativos', 'Baja productividad'],
  includes: ['Rutinas diarias de cubierta', 'Checklist de maniobras', 'Mantenimiento básico estructurado', 'Protocolo de apoyo al capitán', 'Guía de comportamiento profesional'],
  value: {
    crew: 'El marinero deja de improvisar',
    captain: 'Vos ganás control total'
  }
}, {
  icon: '🚀',
  title: 'Manual del Capitán Nuevo™',
  subtitle: 'Qué esperar en tu primer trabajo y cómo destacar desde el día 1',
  resolves: ['Incertidumbre total', 'Miedo al primer trabajo', 'Falta de preparación real'],
  includes: ['Cómo es realmente un día a bordo (sin filtros)', 'Qué te van a pedir (y nadie te dice)', 'Errores que arruinan tu reputación', 'Cómo integrarte con la tripulación', 'Cómo destacarte desde el primer charter', 'Qué hacer antes de subir al barco'],
  value: {
    crew: 'Reduce ansiedad y acelera adaptación',
    captain: 'Aumenta tu valor profesional inmediato'
  },
  isImpact: true
}];
export function BonusSection() {
  return <section className="py-8 md:py-14 bg-navy-950 relative" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-2">
        <div className="text-center mb-6 md:mb-10" data-id="element-3">
          <div className="inline-flex items-center justify-center gap-2 md:gap-3 bg-red-600 text-white px-4 py-2 md:px-6 md:py-3 rounded-full font-bold text-base md:text-xl mb-4 md:mb-6 shadow-[0_0_30px_rgba(220,38,38,0.3)] animate-pulse" data-id="element-4">
            <Gift className="w-5 h-5 md:w-6 md:h-6" data-id="element-5" />Y ADEMÁS… RECIBÍS ESTOS
            BONUS EXCLUSIVOS
          </div>
        </div>

        <div className="space-y-4 md:space-y-6" data-id="element-6">
          {bonuses.map((bonus, index) => <div key={index} className="bg-navy-900 rounded-2xl border border-gold-500/30 overflow-hidden shadow-2xl relative" data-id="element-7">
              {/* Badge */}
              <div className="absolute top-3 right-3 md:top-4 md:right-4 bg-red-600 text-white text-[10px] md:text-xs font-bold px-2 py-1 md:px-3 md:py-1.5 rounded-full shadow-lg transform rotate-3 z-10" data-id="element-8">
                GRATIS POR HOY
              </div>

              <div className="p-4 md:p-6" data-id="element-9">
                <div className="flex items-start gap-3 mb-3 md:mb-4" data-id="element-10">
                  <span className="text-2xl md:text-3xl bg-navy-800 p-2 md:p-3 rounded-xl border border-navy-700" data-id="element-11">
                    {bonus.icon}
                  </span>
                  <div data-id="element-12">
                    <h3 className="text-base md:text-xl font-heading font-bold text-white mb-1" data-id="element-13">
                      BONUS {index + 1} — {bonus.title}
                    </h3>
                    <p className="text-xs md:text-sm text-gold-400 font-medium" data-id="element-14">
                      {bonus.subtitle}
                    </p>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-3 md:gap-4 mt-3 md:mt-4" data-id="element-15">
                  <div className="bg-navy-950/50 p-3 md:p-4 rounded-lg border border-navy-800" data-id="element-16">
                    <h4 className="flex items-center gap-2 text-white font-bold mb-1.5 md:mb-2 text-xs md:text-sm" data-id="element-17">
                      <span data-id="element-18">🔥</span> Qué resuelve:
                    </h4>
                    <ul className="space-y-1 md:space-y-1.5 text-slate-300 text-xs md:text-sm" data-id="element-19">
                      {bonus.resolves.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-20">
                          <span className="text-red-500 mt-0.5 md:mt-1" data-id="element-21">
                            ❌
                          </span>{' '}
                          {item}
                        </li>)}
                    </ul>
                  </div>

                  <div className="bg-navy-950/50 p-3 md:p-4 rounded-lg border border-navy-800" data-id="element-22">
                    <h4 className="flex items-center gap-2 text-white font-bold mb-1.5 md:mb-2 text-xs md:text-sm" data-id="element-23">
                      <span data-id="element-24">📦</span> Qué incluye:
                    </h4>
                    <ul className="space-y-1 md:space-y-1.5 text-slate-300 text-xs md:text-sm" data-id="element-25">
                      {bonus.includes.map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-26">
                          <span className="text-green-500 mt-0.5 md:mt-1" data-id="element-27">
                            ✔
                          </span>{' '}
                          {item}
                        </li>)}
                    </ul>
                  </div>
                </div>

                <div className="mt-3 md:mt-4 bg-gold-500/10 border border-gold-500/20 p-3 md:p-4 rounded-lg" data-id="element-28">
                  <h4 className="flex items-center gap-2 text-gold-400 font-bold mb-1.5 md:mb-2 text-xs md:text-sm" data-id="element-29">
                    <span data-id="element-30">💡</span>{' '}
                    {bonus.isImpact ? 'Impacto directo:' : 'Doble valor:'}
                  </h4>
                  <div className="flex flex-col sm:flex-row gap-2 md:gap-3" data-id="element-31">
                    <div className="flex-1 bg-navy-900 p-2 md:p-3 rounded-lg text-white font-medium border border-navy-700 text-xs md:text-sm" data-id="element-32">
                      👉 {bonus.value.crew}
                    </div>
                    <div className="flex-1 bg-navy-900 p-2 md:p-3 rounded-lg text-white font-medium border border-navy-700 text-xs md:text-sm" data-id="element-33">
                      👉 {bonus.value.captain}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-6 md:mt-10 text-center" data-id="element-34">
          <CTAButton data-id="element-35" />
        </div>
      </div>
    </section>;
}